import Navbar from "../components/Landing/LandingNavbar";
import Footer from "../components/Landing/Footer";
import { v4 as uuidv4 } from "uuid";
import Head from "next/head";

const data = {
  "@context": "http://schema.org",
  "@type": "WebPage",

  name: "SOP AI Tool | SOP Generator | SOP Writing Services",
  description:
    "Use Tootler AI SOP tool for an professional Statement of Purpose. Improve your application with our personalized writing services and leave a great impression.",

  url: "https://tootler.ai/statment-of-purpose-generator",
};

export default function BlogPostsModernPost() {
  return (
    <>
      <Head>
        <meta
          name="title"
          content="SOP AI Tool | SOP Generator | SOP Writing Services I Tootler AI"
        />
        <meta
          name="description"
          content="Use Tootler AI SOP tool for an professional Statement of Purpose. Improve your application with our personalized writing services and leave a great impression."
        />
        <script
          key="structured-data"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
        <link rel="canonical" href="https://tootler.ai/immigration" />
      </Head>
      {/* Blog Post Section: Modern */}
      <Navbar />
      <div className="bg-white">
        <div className="space-y-16 container xl:max-w-7xl mx-auto px-4 py-12 lg:px-8 lg:py-24">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-extrabold mb-4">
              Immigration Bot: Your Virtual Assistant for Immigration Queries
              and Related Work{" "}
            </h2>
          </div>
          {/* END Heading */}

          {/* Blog Post */}
          <article className="prose prose-indigo prose-lg mx-auto">
            <img
              src="/landing/Hero-illustration.svg"
              alt="Featured Image of blog post"
              className="rounded-lg h-72 w-full"
            />
            <p>
              Welcome to the Immigration Bot, your trusted virtual assistant for
              all your immigration-related queries and concerns.
            </p>
            <p>
              Whether you are planning to migrate to a new country, explore work
              opportunities abroad, or simply seeking information on immigration
              processes, I am here to help. With up-to-date knowledge and a vast
              database of immigration regulations, I will provide accurate and
              personalized answers to your questions.
            </p>
            <h3>1. Immigration Procedures:</h3>

            <ul>
              <li>How can I apply for a visa?</li>
              <li>What documents are required for immigration?</li>
              <li>Can you guide me through the immigration process?</li>
              <li>How long does it take to obtain a visa?</li>
            </ul>

            <h3>2. Visa Types:</h3>

            <ul>
              <li>What are the different visa categories available?</li>
              <li>
                Which visa category is suitable for work/study/visit purposes?
              </li>
              <li>
                Are there any specific visa requirements for entrepreneurs or
                investors?
              </li>
              <li>Can I bring my family with me on a dependent visa?</li>
            </ul>

            <h3>3. Work Opportunities:</h3>
            <ul>
              <li>
                Are there job opportunities in a particular country or region?
              </li>
              <li>What are the requirements to work abroad? /</li>
              <li>How can I find a job sponsor in another country?</li>
              <li>
                What are the work permit regulations in different countries?
              </li>
            </ul>
            <h3>4. Immigration Policies:</h3>
            <ul>
              <li>What are the immigration policies of a specific country?</li>
              <li>
                Are there any recent updates or changes in immigration
                regulations?
              </li>
              <li>
                How can I stay informed about changes in immigration policies?
              </li>
              <li>Can you explain the points-based immigration system?</li>
            </ul>
          </article>
          <div className="text-center">
            <a
              href={`sop/new/${uuidv4()}/step-1`}
              className="inline-flex justify-center items-center space-x-2 border font-semibold focus:outline-none px-3 py-2 leading-6 rounded border-gray-300 bg-white text-gray-800 shadow-sm hover:text-gray-800 hover:bg-gray-100 hover:border-gray-300 hover:shadow focus:ring focus:ring-gray-500 focus:ring-opacity-25 active:bg-white active:border-white active:shadow-none"
            >
              <svg
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
                className="transform -rotate-45 opacity-50 hi-solid hi-arrow-right inline-block w-5 h-5"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
              <span>Try Now</span>
            </a>
          </div>
          {/* END Blog Post */}
        </div>
      </div>
      {/* END Blog Post Section: Modern */}
      <Footer />
    </>
  );
}
